import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";

import {
    Header,
    Input,
    Grid,
    Button,
    Form,
    InputOnChangeData,
    Dropdown,
    DropdownProps,
} from "semantic-ui-react";

import TableApp, { ITableAppRender } from "../../components/TableApp";
import MaskedInput from "../../components/MaskedInput";

import { IKit, IItemKit, HttpStatusCode } from "../../interfaces";
import KitRepository from "../../Repositories/KitRepository";
import ConferenceRepository from "../../Repositories/ConferenceRepository";
import ItemKitRepository from "../../Repositories/ItemKitRepository";
import ProdutoRepository, {
    IProdutoListModel,
} from "../../Repositories/ProdutoRepository";

import NumberFormat from "../../Utils/NumberFormat";
import errors from "../../Utils/ExtractErrors";
import { RouteComponentProps, Redirect } from "react-router-dom";
import { format } from "date-fns";
import ModalYesNo from "../../components/ModalYesNo";
import TemplateMain from "../../components/TemplateMain";
import { GetUser } from "../../services/auth";
import VincularKit from "./VincularKit";
import ResellersRepository from "../../Repositories/ResellersRepository";

interface IItemModel extends IItemKit {
    item: number;
    codigo: string | undefined;
    descricao: string | undefined;
}

interface IState extends IKit {
    openContinuar: boolean;
    openFinalize: boolean;
    disableButton: boolean;
}

interface IProps {
    id: string;
}

interface ILocationState {
    id: string;
    gerenteSetor: string;
    representante: string;
    revendedor: string;
    acerto: string;
    month: number;
    status: number;
    valorVendido: string;
}

const initialState: IState = {
    openContinuar: false,
    openFinalize: false,
    id: "",
    data: "",
    numero: 0,
    valor: 0,
    statusKit: 0,
    pedidoId: "",
    revendedorId: "",
    prorrogado: 0,
    estado: 0,
    tipo: 0,
    nomeOperador: "",
    disableButton: false,
};

const ConferenceKit: React.FC<
    RouteComponentProps<IProps, any, ILocationState>
> = ({ match, location }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [saving, setSaving] = useState<boolean>(false);
    const [produtos, setProdutos] = useState<IProdutoListModel[]>([]);
    const [itemsKit, setItemsKit] = useState<IItemKit[]>([]);
    const [codigo, setCodigo] = useState<string>("");
    const [valorRecebido, setValorRecebido] = useState<string>("");
    const [valorVendido, setValorVendido] = useState<string>("");

    const [state, setState] = useState<IState>(initialState);
    const [items, setItems] = useState<IItemKit[]>([]);
    const [tableList, setTablelist] = useState<IItemModel[]>([]);
    const [redirect, setRedirect] = useState<boolean>(false);
    const [produtoDrop, setProdutoDrop] = useState<string>("");

    const { role } = GetUser();

    const LoadKit = useCallback(async () => {
        setLoading(true);
        try {
            const [kit, produtos, kitItems, conference] = await Promise.all([
                KitRepository.GetById(match.params.id),
                ProdutoRepository.List({ filter: "STATUS == 1" }),
                ItemKitRepository.ListByKitId(match.params.id),
                role === "Operador"
                    ? ConferenceRepository.GetConferenceByKitId(match.params.id)
                    : undefined,
            ]);

            if (conference) {
                setValorVendido(NumberFormat.Currency(conference.valorVendido));
                setValorRecebido(
                    NumberFormat.Currency(conference.valorRecebido)
                );
            }

            setState((state) => ({ ...state, ...kit }));
            setProdutos(produtos.list);
            setItemsKit(kitItems);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }, [match.params.id, role]);

    const handleOnChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        data: InputOnChangeData
    ) => {
        setCodigo(data.value);
    };

    const handleOnChangeValorRecebido = (
        event: React.ChangeEvent<HTMLInputElement>,
        data: InputOnChangeData
    ) => {
        setValorRecebido(data.value);
    };

    const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") handleAddItem();
    };

    const handleAddItem = () => {
        const item = produtos.find(
            (x) =>
                x.codigo.toUpperCase() ===
                `${produtoDrop}${codigo}`.toUpperCase()
        );
        const kitItem = itemsKit.find(
            (kitItem) => kitItem.produtoId === item?.id
        );

        if (item !== undefined && kitItem !== undefined) {
            const updatedKitItems = itemsKit.filter((item) => item !== kitItem);

            setCodigo("");
            setItems([
                {
                    quantidade: 1,
                    statusItemKit: 0,
                    kitId: match.params.id,
                    produtoId: item.id,
                    valor: item.valor,
                },
                ...items,
            ]);

            setItemsKit(updatedKitItems);
        } else {
            toast("Produto do kit não encontrado", {
                position: "top-center",
                type: "error",
            });
        }
    };

    const handleRemoveItem = (index: number) => {
        const item = items.find((x, i) => i === index);

        if (item !== undefined) {
            const newItems = items.filter((x, i) => i !== index);

            setItemsKit((itemsKit) => [...itemsKit, item]);
            setItems(newItems);
        }
    };

    const handleTableData = useCallback(() => {
        let data: IItemModel[] = [];
        let contador: number = items.length;

        items.map((itemkit) => {
            return data.push({
                item: contador--,
                ...itemkit,
                codigo: produtos.find(
                    (produto) => produto.id === itemkit.produtoId
                )?.codigo,
                descricao: produtos.find(
                    (produto) => produto.id === itemkit.produtoId
                )?.nome,
            });
        });

        setTablelist(data);
    }, [items, produtos]);

    const handleFinalizar = async () => {
        state.disableButton = true;

        if (valorRecebido.length <= 0) {
            return toast("O valor recebido é obrigatório.", {
                position: "top-center",
                type: "error",
            });
        }
        const valor = parseFloat(
            valorRecebido.replace(".", "").replace(",", ".")
        );
        if (valor > handleValorReceber()) {
            return toast(
                "O valor recebido não pode ser maior que o valor à receber.",
                { position: "top-center", type: "error" }
            );
        }
        setSaving(true);
        try {
            const valor = parseFloat(
                valorRecebido
                    .replace(".", "")
                    .replace(",", ".")
                    .replace("R$", "")
                    .trim()
            );

            const response = await KitRepository.Check({
                id: match.params.id,
                items: items,
                valor,
            });

            setRedirect(true);

            toast(response.message, {
                position: "top-center",
                type: "success",
            });
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setSaving(false);
    };

    const handleFinalizarNaoContinua = async () => {
        if (valorRecebido.length <= 0) {
            return toast("O valor recebido é obrigatório.", {
                position: "top-center",
                type: "error",
            });
        }
        const valor = parseFloat(
            valorRecebido.replace(".", "").replace(",", ".")
        );
        if (valor > handleValorReceber()) {
            return toast(
                "O valor recebido não pode ser maior que o valor à receber.",
                { position: "top-center", type: "error" }
            );
        }
        setSaving(true);
        try {
            const responseInactive = await ResellersRepository.Inactive(
                state.revendedorId || ""
            );

            if (responseInactive.status === HttpStatusCode.Ok) {
                const valor = parseFloat(
                    valorRecebido
                        .replace(".", "")
                        .replace(",", ".")
                        .replace("R$", "")
                        .trim()
                );

                const response = await KitRepository.Check({
                    id: match.params.id,
                    items: items,
                    valor,
                });

                setRedirect(true);

                toast(response.message, {
                    position: "top-center",
                    type: "success",
                });
            }
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setSaving(false);
    };

    const tableRender: ITableAppRender[] = [
        {
            header: "Item",
            content: (x: IItemModel) => x.item,
            textAlign: "center",
            width: 1,
        },
        {
            header: "Código",
            content: (x: IItemModel) => x.codigo,
            textAlign: "center",
            width: 2,
        },
        {
            header: "Descrição",
            content: (x: IItemModel) => x.descricao,
            width: 10,
        },
        {
            header: "Valor",
            content: (x: IItemModel) => NumberFormat.Currency(x.valor),
            textAlign: "center",
            width: 1,
        },
    ];

    const handleValorVendido = () => {
        return (
            state.valor -
            items.reduce((accumulator: number, item: IItemKit) => {
                return (accumulator += item.valor);
            }, 0)
        );
    };

    const handleComissaoRevendedor = () => {
        if (handleValorVendido() <= 149) {
            return "10%";
        }
        if (handleValorVendido() <= 499) {
            return "20%";
        }
        if (handleValorVendido() <= 1199) {
            return "30%";
        }
        if (handleValorVendido() <= 2499) {
            return "40%";
        }
        if (handleValorVendido() >= 2500) {
            return "50%";
        }
    };

    const handleValorReceber = () => {
        const valorVendido = handleValorVendido();
        if (handleValorVendido() <= 149) {
            return valorVendido - (valorVendido * 0.1)
        }
        if (handleValorVendido() <= 499) {
            return valorVendido - (valorVendido * 0.2)
        }
        if (handleValorVendido() <= 1199) {
            return valorVendido - (valorVendido * 0.3)
        }
        if (handleValorVendido() <= 2499) {
            return valorVendido - (valorVendido * 0.4)
        }
        return valorVendido - (valorVendido * 0.5);
    };

    const handleDiff = () => {
        const diference =
            parseFloat(valorVendido.replace("R$", "").replace(".", "")) -
            handleValorVendido();
        return diference;
    };

    useEffect(() => {
        LoadKit();
    }, [LoadKit]);
    useEffect(() => {
        handleTableData();
    }, [handleTableData, items]);

    const defaultFinalizar = (
        trigger: JSX.Element,
        onSuccess: VoidFunction
    ) => (
        <ModalYesNo
            open={state.openFinalize}
            trigger={trigger}
            header="Finalizar conferência"
            content={`Confirma a conferência do kit nº ${state.numero}?`}
            onSuccess={
                <Button
                    content="Sim"
                    color="pink"
                    disabled={saving}
                    loading={saving}
                    onClick={onSuccess}
                />
            }
            onCancel={
                <Button
                    content="Nao"
                    onClick={() =>
                        setState((state) => ({
                            ...state,
                            openFinalize: false,
                            openContinuar: false,
                        }))
                    }
                />
            }
        />
    );

    const onDropdownChange = (
        event: React.SyntheticEvent<HTMLElement, Event>,
        data: DropdownProps
    ) => {
        const { value } = data;
        setProdutoDrop(data.value as string);
    };

    const produtosOptions = [
        { key: "Código do Produto", text: "Código do Produto", value: "" },
        { key: "Brincos", text: "Brincos", value: "B" },
    ];

    const content = (
        <Grid columns="equal">
            <Grid.Row>
                <Grid.Column>
                    <Header
                        size="huge"
                        content={`KIT: ${state.numero}`}
                        icon="calendar check outline"
                    />
                </Grid.Column>
                <Grid.Column>
                    <MaskedInput
                        fluid
                        readOnly
                        mask="data"
                        icon="calendar alternate"
                        iconPosition="left"
                        placeholder="Data acerto"
                        value={
                            location.state.acerto
                                ? format(
                                      new Date(location.state.acerto),
                                      "dd/MM/yyyy"
                                  )
                                : ""
                        }
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Form>
                        {role === "Operador" && (
                            <>
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <Form.Input
                                            fluid
                                            readOnly
                                            label="Revendedor"
                                            placeholder="Indefinido"
                                            value={location.state.revendedor}
                                        />
                                    </Form.Field>

                                    <Form.Field>
                                        <Form.Input
                                            action={{
                                                color: "blue",
                                                icon: "stopwatch",
                                            }}
                                            actionPosition="left"
                                            fluid
                                            readOnly
                                            label="Pré-Conferencia"
                                            placeholder="Indefinido"
                                            value={valorVendido}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label>Conf. Empresa</label>
                                        <MaskedInput
                                            action={{
                                                color: "olive",
                                                icon: "industry",
                                            }}
                                            actionPosition="left"
                                            fluid
                                            readOnly
                                            mask="currency"
                                            placeholder="Valor vendido"
                                            value={NumberFormat.Currency(
                                                handleValorVendido()
                                            )}
                                        />
                                    </Form.Field>
                                    {handleDiff() > 0 ? (
                                        <Form.Field>
                                            <Form.Input
                                                action={{
                                                    color: "green",
                                                    icon: "plus",
                                                }}
                                                actionPosition="left"
                                                fluid
                                                readOnly
                                                label="Diferença"
                                                placeholder="Indefinido"
                                                value={NumberFormat.Currency(
                                                    handleDiff()
                                                )}
                                            />
                                        </Form.Field>
                                    ) : handleDiff() === 0 ? (
                                        <Form.Field>
                                            <Form.Input
                                                action={{
                                                    color: "grey",
                                                    icon: "check",
                                                }}
                                                actionPosition="left"
                                                fluid
                                                readOnly
                                                label="Diferença"
                                                placeholder="Indefinido"
                                                value="Sem Diferença"
                                            />
                                        </Form.Field>
                                    ) : (
                                        <Form.Field>
                                            <Form.Input
                                                action={{
                                                    color: "red",
                                                    icon: "minus",
                                                }}
                                                actionPosition="left"
                                                fluid
                                                readOnly
                                                label="Diferença"
                                                placeholder="Indefinido"
                                                value={NumberFormat.Currency(
                                                    handleDiff() * -1
                                                )}
                                            />
                                        </Form.Field>
                                    )}
                                </Form.Group>
                            </>
                        )}
                        {role === "Representante" && (
                            <>
                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label>Valor vendido</label>
                                        <MaskedInput
                                            fluid
                                            readOnly
                                            mask="currency"
                                            placeholder="Valor vendido"
                                            value={NumberFormat.Currency(
                                                handleValorVendido()
                                            )}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Comissão</label>
                                        <MaskedInput
                                            fluid
                                            readOnly
                                            mask="currency"
                                            placeholder="Comissão"
                                            value={handleComissaoRevendedor()}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Valor à receber</label>
                                        <MaskedInput
                                            fluid
                                            readOnly
                                            mask="currency"
                                            placeholder="Valor à receber"
                                            value={NumberFormat.Currency(
                                                handleValorReceber()
                                            )}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Field>
                                    <label>Valor Recebido</label>
                                    <MaskedInput
                                        fluid
                                        mask="currency"
                                        label={"R$"}
                                        placeholder="Valor recebido"
                                        value={valorRecebido}
                                        onChange={handleOnChangeValorRecebido}
                                    />
                                </Form.Field>
                            </>
                        )}
                    </Form>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    {role === "Representante" &&
                        state.revendedorId !== null && (
                            <>
                                <ModalYesNo
                                    open={state.openContinuar}
                                    trigger={
                                        <Button
                                            fluid
                                            disabled={
                                                valorRecebido.length === 0 ||
                                                (handleValorVendido() !== 0 &&
                                                    state.revendedorId === null)
                                            }
                                            icon="check"
                                            color="pink"
                                            content="Finalizar"
                                            loading={saving}
                                            onClick={() =>
                                                setState((state) => ({
                                                    ...state,
                                                    openContinuar: true,
                                                }))
                                            }
                                        />
                                    }
                                    header="Atenção"
                                    content={`Revendedor(a) irá continuar?`}
                                    onSuccess={
                                        <VincularKit
                                            revendedorId={
                                                state.revendedorId || ""
                                            }
                                            onSuccess={handleFinalizar}
                                            onClose={() =>
                                                setState((state) => ({
                                                    ...state,
                                                    openContinuar: false,
                                                    openFinalize: false,
                                                }))
                                            }
                                        />
                                    }
                                    onCancel={defaultFinalizar(
                                        <Button
                                            content="Não"
                                            onClick={() =>
                                                setState((state) => ({
                                                    ...state,
                                                    openFinalize: true,
                                                }))
                                            }
                                        />,
                                        handleFinalizarNaoContinua
                                    )}
                                />
                            </>
                        )}
                    {(role === "Operador" ||
                        (role === "Representante" &&
                            state.revendedorId === null)) &&
                        defaultFinalizar(
                            <Button
                                fluid
                                disabled={valorRecebido.length === 0}
                                icon="check"
                                color="pink"
                                content="Finalizar"
                                loading={saving}
                                onClick={() =>
                                    setState((state) => ({
                                        ...state,
                                        openFinalize: true,
                                    }))
                                }
                            />,
                            handleFinalizar
                        )}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    {role === "Operador" ? (
                        <Input
                            fluid
                            label={
                                <Dropdown
                                    placeholder="Código do Produto"
                                    defaultValue="Código do Produto"
                                    options={produtosOptions}
                                    onChange={onDropdownChange}
                                    value={produtoDrop}
                                />
                            }
                            placeholder="Insira o código do produto"
                            onChange={handleOnChange}
                            onKeyDown={handleOnKeyDown}
                            value={codigo}
                            action={{
                                icon: "add",
                                color: "pink",
                                onClick: handleAddItem,
                            }}
                        />
                    ) : (
                        <Input
                            fluid
                            label="Código do produto"
                            placeholder="Insira o código do produto"
                            onChange={handleOnChange}
                            onKeyDown={handleOnKeyDown}
                            value={codigo}
                            action={{
                                icon: "add",
                                color: "pink",
                                onClick: handleAddItem,
                            }}
                        />
                    )}
                </Grid.Column>
            </Grid.Row>
            <Grid.Column>
                <Grid.Row>
                    <TableApp
                        render={tableRender}
                        list={tableList}
                        actions={(data: IItemModel, index: number) => {
                            return [
                                <ModalYesNo
                                    trigger={
                                        <Button icon="trash" color="red" />
                                    }
                                    header="Apagar"
                                    content="Deseja realmente apagar este item?"
                                    onSuccess={() => {
                                        handleRemoveItem(index);
                                    }}
                                />,
                            ];
                        }}
                        loading={false}
                    />
                </Grid.Row>
            </Grid.Column>
        </Grid>
    );

    return (
        <>
            {redirect && (
                <Redirect
                    to={{
                        pathname: `/conferencelist`,
                        state: {
                            month: location.state.month,
                            status: location.state.status,
                        },
                    }}
                />
            )}

            {!redirect && <TemplateMain loading={loading} content={content} />}
        </>
    );
};

export default ConferenceKit;
